import React from "react";
import EquipmentUsageTable from "./components/EquipmentUsageTable";

export default function EquipmentUsage() {
  return (
    <div className="grid h-full min-h-0 grid-cols-1 gap-5">
      <EquipmentUsageTable />
    </div>
  );
}


